import { FC } from 'react';
import { Box, CircularProgress, Stack, Typography } from '@mui/material';
import { Done, Insights, TaskAlt } from '@mui/icons-material';


export const StoryAnalysisLoader: FC = () => {
  return (
    <Stack justifyContent="center" alignItems="center" height="100%" py={3}>
      <Stack justifyContent="center" alignItems="center" height="100%" position="relative">
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <TaskAlt sx={{ fontSize: 26, color: 'primary.main', opacity: 0.5 }}/>
        </Box>
        <CircularProgress size={60} thickness={2}/>
      </Stack>
      <Typography variant="body1" fontWeight={700} fontSize={20} mt={2} textAlign="center">
        Analyzing your leadership story...
      </Typography>
      <Stack justifyContent="center" alignItems="center" width="100%" mt={1}>
        <Stack direction="row" justifyContent="center" alignItems="center" gap={1} mt={1}>
          <Done sx={{ color: 'primary.main', fontSize: 16 }}/>
          <Typography variant="body2" color="text.secondary" fontWeight={500}>
            Processing communication objectives
          </Typography>
        </Stack>

        <Stack direction="row" justifyContent="center" alignItems="center" gap={1} mt={1}>
          <Done sx={{ color: 'primary.main', fontSize: 16 }}/>
          <Typography variant="body2" color="text.secondary" fontWeight={500}>
            Analyzing leadership values alignment
          </Typography>
        </Stack>

        <Stack direction="row" justifyContent="center" alignItems="center" gap={1} mt={1}>
          <Done sx={{ color: 'primary.main', fontSize: 16 }}/>
          <Typography variant="body2" color="text.secondary" fontWeight={500}>
            Evaluating story communication patterns
          </Typography>
        </Stack>
        <Stack direction="row" justifyContent="center" alignItems="center" gap={1} mt={1}>
          <Insights sx={{ color: 'primary.main', fontSize: 16 }}/>
          <Typography variant="body2" color="primary.insights" fontWeight={500}>
            Generating personalized insights
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
};
